import OptimizationStore from '../../../store/OptimizationStore';
import * as keys from './keys';
import Validator from './validator';

import { gcap } from '../../../store/gcap';
import * as Constants from "constants/Constants"

class Utils {
  getCoverAmountList = () => {
    let list = [];
    for (let index = 1; index <= 100; index++) {
      if (index != 100) {
        list.push({
          id: index == 0 ? 1 : index,
          label: (index == 0 ? 1 : index) + " L",
        });
      } else {
        list.push({
          id: index,
          label: 1 + " Cr.",
        });
      }
    }
    return list;
  };

  getCoverAmountListForCLRnHCB = () => {
    let list = [];
    for (let index = 1; index <= 50; index++) {
      list.push({
        id: index == 0 ? 1 : index,
        label: (index == 0 ? 1 : index) + " L",
      });
    }
    return list;
  };

  pptValueBasedOnPt = (ptValue,formRef) => {

    let pptList = [
      {
        id: 5,
        label: 5
      },
      {
        id: 7,
        label: 7
      },
      {
        id: 10,
        label: 10
      },
      {
        id: 12,
        label: 12
      }
    ]

    if(ptValue === '10'){
      formRef.$('premium-term').set('extra', {
        ...formRef.$('premium-term').extra,
        optionList: pptList.slice(0,2)
    })
    }else{
      formRef.$('premium-term').set('extra', {
        ...formRef.$('premium-term').extra,
        optionList: pptList
    })
    }

  }

  updateBi = (key, value, productId, formRef, productData) => {
    
    let selectedRiskType = productData?.data?.selectedRisk;
    let selectedRiskProductObject = productData?.data?.BI.filter((item) => item.risk == selectedRiskType)[0];
    let biData = OptimizationStore.fetchBiRequest(productId, selectedRiskProductObject.family_product_id);
    let biRequest = biData.data.bi_request

    switch (key) {
      case keys.PAYOUT_OPTION:
        biRequest[keys.PAYOUT_OPTION] = value
        break;

      case keys.FREQUENCY:
        let premiumAmount = 0;
        let amount = value.premium;
        switch (Number(value.frequency)) {
          case 1:
            premiumAmount = '' + amount * 1
            break;
          case 2:
            premiumAmount = '' + amount * 2
            break;
          case 3:
            premiumAmount = '' + amount * 4
            break;
          case 4:
            premiumAmount = '' + amount * 12
            break;
        }

        biRequest[keys.PREMIUM] = premiumAmount
        biRequest[keys.FREQUENCY] = value.frequency
        break;

      case keys.PR_PT:
        biRequest[keys.PR_PT] = value
        break;

      case keys.PR_PPT:
        biRequest[keys.PR_PPT] = value
        break;

      case keys.PREMIUM:
        biRequest[keys.PREMIUM] = value
        break;

      case keys.WOP_RIDER:
        biRequest[keys.WOP_RIDER] = value
        break

      case keys.ADB_RIDER:
        if (value) {
          biRequest[keys.ADB_RIDER] = value;
        } else {
          biRequest[keys.ADB_RIDER] = '';
        }
        break;

      case keys.ATPD_RIDER:
        if (value) {
          biRequest[keys.ATPD_RIDER] = value;
        } else {
          biRequest[keys.ATPD_RIDER] = '';
        }
        break;

      case keys.Critical_ILLNESS_RIDER:
        if (value) {
          biRequest[keys.Critical_ILLNESS_RIDER] = value;
        } else {
          biRequest[keys.Critical_ILLNESS_RIDER] = '';
        }
        break;

      case keys.INCOME_BENEFIT_RIDER:
        if (value) {
          biRequest[keys.INCOME_BENEFIT_RIDER] = value
        } else {
          biRequest[keys.INCOME_BENEFIT_RIDER] = '';
        }
        break;

      case keys.PWB_RIDER:
        if (value) {
          biRequest[keys.PWB_RIDER] = '1'
          biRequest.PWB = '' + value
        } else {
          biRequest[keys.PWB_RIDER] = '';
        }
        break;

    }

    OptimizationStore.updateBiRequest(productId, biRequest, productData.data.family_product_id, key, value)
    // let errorMessage = Validator.valid(formRef, biData);

    // if (errorMessage.length > 0) {
    //   return
    // }

    // OptimizationStore.updateStoreRequestData(productId, biRequest, key, value)
  }

  getTotalPrice = (data) => {
    try {
      return Math.round(data.PREM_DISPLAY)
    } catch (e) {
      return 0
    }
  }

  getRiderTax = (data) => {
    let totalRider = 0;
    data?.parsedResponse?.inputValidationStatus?.map((item) => {
      totalRider += Number(item.Tax)
    })
    return totalRider;
  }

  // fetchPolicyTimeline(element, frequency) {
  //   let amount = Math.round(element.MODAL_PREM);
  //   let premiumAmount = ''
  //   switch (frequency.Value) {
  //     case '1':
  //       premiumAmount = '' + amount * 1
  //       break;
  //     case '2':
  //       premiumAmount = '' + amount * 2
  //       break;
  //     case '3':
  //       premiumAmount = '' + amount * 4
  //       break;
  //     case '4':
  //       premiumAmount = '' + amount * 12
  //       break;
  //   }
  //   let data = {
  //     youPay: Math.round(premiumAmount),
  //     youGet: Math.round(element.TOTAL_SB_G) || 0,
  //     lifeCover: Math.round(element.TOTAL_DB_G),
  //     isMilestone: Math.round(element.TOTAL_SB_G) !== 0,
  //     premiumAmt: Math.round(element.ANN_PREM_YEARLY)
  //   }
  //   return data
  // }

  
  newPolicyTimeLineData(element,inputString,index, policyTerm) {

    const {MODAL_PREM,TOTAL_SB_G,SAD,DB_G, SA_D, MATURITY, ANN_PREM_YEARLY} = element

    let premiumAmount = 0;

     let inputMode = parseInt(inputString.find(item => item.Key === '@INPUT_MODE').Value)

    //  if (inputMode === 1) {
    //    premiumAmount = Math.round(MODAL_PREM) * Constants.ANNUAL_MODAL_FACTOR;
    //  } else if (inputMode === 2) {
    //    premiumAmount = Math.round(MODAL_PREM) * Constants.SEMI_ANNUAL_MODAL_FACTOR;
    //  } else if (inputMode === 3) {
    //    premiumAmount = Math.round(MODAL_PREM) * Constants.QUATERLY_MODAL_FACTOR;
    //  } else if (inputMode === 4) {
    //    premiumAmount = Math.round(MODAL_PREM) * Constants.MONTHLY_MODAL_FACTOR;
    //  }

    let data = {
      youPay:Math.round(ANN_PREM_YEARLY),
      youGet: index == policyTerm - 1 ?  Math.round(MATURITY) : 0,
      lifeCover:Math.round(SA_D)
    }

    return data
  }
}

export default new Utils();
